<div>
    <div class="padding-10" *ngIf="cirfFormGroup">
        <form [formGroup]="cirfFormGroup">
                <div formGroupName="cirfMatterData">
                    <div *ngIf="!cirf?.isCustomMatter() && showMatterInfoStep && isSelectedSectionMatterContactInfo()">
                        <h2 class="display-block header-text semi-bold-font">Matter Contact Info</h2>
                        <span class="header-details">
                            <i class="fa fa-info-circle padding-right-5"></i>Please enter the contact information for this transaction.
                        </span>
                        <div formGroupName="matterContactInfo">
                            <div class="row col-12 padding-left-0 padding-right-0" >
                                <ng-container *ngIf="cirf?.isMatterPurchase()">
                                    <div class="col-12 col-lg-6 padding-left-0" [dp-field-visibility]="'matterContactInfo.clientCapacity'">
                                        <mat-form-field >
                                            <mat-label
                                                    [dp-province-field-label]="'cirfMatterData.capacity'"
                                                    [label-province-code] = "cirf?.provinceCode">Capacity
                                            </mat-label>
                                            <select matNativeControl formControlName="clientCapacity" my-auto-focus aria-label="Select Capacity">
                                                <option *ngFor="let option of matterPurchasersCapacityOptions"
                                                        [value]="option.value">{{ option.name }}
                                                </option>
                                            </select>
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-6 padding-left-0" [dp-field-visibility]="'matterContactInfo.clientCapacity'">
                                        <div>
                                            <i class="fa fa-info-circle padding-right-5"></i>
                                            <span>Joint tenants includes the right of survivorship,
                                                whereas tenants in common does not.
                                                The right of survivorship means that the interest held between the joint tenants
                                                would flow to the survivor on the death of a registered owner.
                                                Under tenants in common, when one of the owners passes away,
                                                their share in the property will pass to their beneficiaries in accordance with their Will.</span>

                                        </div>
                                    </div>

                                </ng-container>
                            </div>
                            <div class="row col-12 padding-left-0 padding-right-0" >
                                <div class="col-12 col-lg-6 padding-left-0" [dp-field-visibility]="'matterContactInfo.residingAtSubjectProperty'">
                                    <mat-form-field  >
                                        <mat-label>{{cirf?.isMatterSale() || cirf?.isMatterMortgage() ? 'Do you reside at the subject property?'
                                            :
                                            'Will you be residing at the subject property?'}}
                                        </mat-label>
                                        <select matNativeControl formControlName="residingAtSubjectProperty" my-auto-focus aria-label="Will you be residing at the subject property?">
                                            <option *ngFor="let option of yesNoOptionsMandatory" [value]="option.value">
                                                {{
                                                option.name }}
                                            </option>
                                        </select>
                                        <mat-error>This field is required</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <dp-address-form *ngIf="isClosingAddressVisible()"
                                             [formGroup]="matterContactInfoFormGroup"
                                             [formGroupName]="cirf?.isMatterPurchase() ? 'preClosingAddress' : 'postClosingAddress'"
                                             [addressLine1Label]="addressLine1LabelDisplay"
                                             [prefixForVisibilityKey]="'matterContactInfo.address'"
                            ></dp-address-form>
                            <dp-cirf-udf
                                    [formGroup]="matterContactInfoFormGroup"
                                    [cirfFormArrayName]="'matterContactInfoUdfs'"
                                    [cirfUdfFieldKey]="matterContactInfoUdfFieldKey"
                                    [cirfUdfs]="matterContactInfoUdfs"
                            ></dp-cirf-udf>
                        </div>
                    </div>
                    <ng-container *ngIf="showInsuranceStep && isSelectedSectionInsuranceDetails()">
                        <div>
                            <h2 class="display-block header-text semi-bold-font">New Insurance Details</h2>
                            <span class="header-details">
                                <i class="fa fa-info-circle padding-right-5"></i>Please enter the new insurance details for this transaction.
                            </span>
                            <div formGroupName="fireInsuranceDetail">
                                <div class="row col-12 padding-left-0 padding-right-0" >
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'fireInsuranceDetail.companyName'">
                                        <mat-form-field >
                                            <mat-label>Name of Company</mat-label>
                                            <input matInput formControlName="companyName" my-auto-focus maxlength="200">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'fireInsuranceDetail.policyNumber'">
                                        <mat-form-field >
                                            <mat-label>Policy No.</mat-label>
                                            <input matInput formControlName="policyNumber" maxlength="30">
                                            <mat-error>This field is required</mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div formGroupName="insuranceBroker">
                                    <div class="row col-12 padding-left-0 padding-right-0" >
                                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'fireInsuranceDetail.broker.name'">
                                            <mat-form-field  >
                                                <mat-label>Name of Broker</mat-label>
                                                <input matInput formControlName="name" maxlength="100">
                                                <mat-error>This field is required</mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'fireInsuranceBroker.phone1.telephoneNumber'">
                                            <ng-container formArrayName="telephones">
                                                <mat-form-field  formGroupName="0" >
                                                    <mat-label>Phone Number</mat-label>
                                                    <input matInput formControlName="telephoneNumber" dp-phone-number>
                                                    <mat-error>This field is required</mat-error>
                                                </mat-form-field>
                                            </ng-container>
                                        </div>
                                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="'fireInsuranceDetail.broker.email'">
                                            <mat-form-field  >
                                                <mat-label>Email</mat-label>
                                                <input matInput formControlName="email" maxlength="100">
                                                <mat-error *ngIf="cirfFormGroup.controls?.cirfMatterData.controls?.fireInsuranceDetail.controls?.insuranceBroker.controls?.email.errors?.required">Email is required</mat-error>
                                                <mat-error *ngIf="cirfFormGroup.controls?.cirfMatterData.controls?.fireInsuranceDetail.controls?.insuranceBroker.controls?.email.errors?.email">Email must be a valid email address</mat-error>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>
                                <dp-cirf-udf
                                        [formGroup]="insuranceFormGroup"
                                        [cirfFormArrayName]="'insuranceUdfs'"
                                        [cirfUdfFieldKey]="insuranceUdfFieldKey"
                                        [cirfUdfs]="insuranceUdfs"
                                ></dp-cirf-udf>

                        </div>
                            <div class="padding-top-10">
                                <mat-form-field class="width-100" [dp-field-visibility]="'insuranceNotes'" >
                                    <mat-label>Fire Insurance Notes</mat-label>
                                    <textarea rows="3" matInput formControlName="insuranceNotes"></textarea>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="showMatterNotesStep && isSelectedSectionMatterNotes()">
                        <h2 class="display-block header-text semi-bold-font">General Matter Notes</h2>
                        <span class="header-details">
                            <i class="fa fa-info-circle padding-right-5"></i>Please add any additional notes that may be relevant to the transaction.
                        </span>
                        <div class="padding-top-10">
                            <mat-form-field class="width-100" [dp-field-visibility]="'matterNotes'">
                                <mat-label>General Matter Notes</mat-label>
                                <textarea rows="3" matInput formControlName="matterNotes" my-auto-focus></textarea>
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="isSelectedSectionAdditionalAttachments()">
                        <span class="header-details">
                            <i class="fa fa-info-circle padding-right-5"></i>Please add any supporting documents by selecting the upload button.
                        </span>
                        <div *ngIf="(cirf?.isMatterSale() || cirf?.isMatterMortgage()) && !mostRecentTaxBillDocument">
                            <div class="padding-top-10">
                                <h3>Please Upload the Most Recent Tax Bill</h3>
                            </div>
                            <div class="padding-top-10">
                                <dp-file-upload [uploadBtnLabel]="'Upload Most Recent Tax Bill'"
                                                [documentDescription]="mostRecentTaxBillDescription"
                                                (documentUploaded)="documentUploaded($event)"
                                ></dp-file-upload>
                            </div>
                        </div>
                        <h2 class="display-block header-text semi-bold-font">Additional Attachments</h2>
                        <div class="padding-top-10">
                            <dp-file-upload
                                    (documentUploaded)="documentUploaded($event)"
                            ></dp-file-upload>
                        </div>
                        <div class="padding-top-10">
                            <mat-list role="list">
                                <mat-list-item role="listitem" *ngFor="let document of cirfDocuments;let index=index"
                                               (mouseenter)="hoveredIndex=index">
                                    <div class="mat-card-connect-client-list-left">
                                        <mat-icon class="mat-card-connect-icon" title="{{document.description}}"
                                                  *ngIf="document.isVirusClean()">attachment
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                                  *ngIf="document.isVirusInfected()">block
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                                  *ngIf="document.isVirusPending()">warning
                                        </mat-icon>
                                        <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                                  *ngIf="document.isVirusInProgress()">warning
                                        </mat-icon>
                                        <span class="mat-card-list-text">{{document.documentName}} - {{document.description}}</span>

                                    </div>
                                    <div class="mat-card-connect-client-list-right" *ngIf="index==hoveredIndex">
                                        <button class="mat-card-icon" mat-icon-button aria-label="Delete document"
                                                (click)="deleteDocument(document)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <mat-divider></mat-divider>
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </div>
                </div>
        </form>
    </div>
</div>
